import { render } from "./Must.vue?vue&type=template&id=b88a7038&scoped=true"
import script from "./Must.vue?vue&type=script&lang=js"
export * from "./Must.vue?vue&type=script&lang=js"

import "./Must.vue?vue&type=style&index=0&id=b88a7038&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b88a7038"]])

export default __exports__